
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import { Prop } from 'vue-property-decorator'
import { DepartmentResourceType } from '@/modules/department/models/department-resource.model'
import AdminDepartmentEditForm from '@/modules/department/components/admin/form/AdminDepartmentEditForm.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'دپارتمان'
  },
  metaInfo: {
    title: 'دپارتمان'
  },
  components: {
    BaseCard,
    AdminDepartmentEditForm
  }
})
export default class AdminDepartmentShowPage extends Vue {
  @Prop() department: DepartmentResourceType
}
